import { useState, useEffect } from "react";

const useOnScreen = (ref: any, rootMargin = "0px") => {
  const [isIntersecting, setIntersecting] = useState<boolean>(false);

  useEffect(() => {
    const reff = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    
    if (reff) {
      observer.observe(reff);
    }
    return () => {
      reff && observer.unobserve(reff);
    };
    // eslint-disable-next-line
  }, []); // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting;
};

export default useOnScreen;
